import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: false,

  api: {
    rest: {
      auth: 'http://localhost:5003/api/Auth',
      customers: 'http://localhost:5003/api/Customer',
      users: 'http://localhost:5003/api/Users',
      profile: 'http://localhost:5003/api/Profile',
      invoices: 'http://localhost:5003/api/invoices',
      proceeds: 'http://localhost:5003/api/proceeds',
      financialFile: 'http://localhost:5003/api/financialFile',
      volumes: 'http://localhost:5003/api/volumes',
      volumesFile: 'http://localhost:5003/api/volumes-file',
      cards: 'http://localhost:5003/api/Cards'
    }
  },

  defaultLanguage: 'ro',

  mocks: {
    auth: false,
    customers: false,
    users: false,
    invoices: false,
    proceeds: false,
    cards: false
  },

  permissionsRequired: true,

  cookie: {
    domain: 'artoilportal.ro',
    cookiePolicyURL: 'https://artoilportal.ro/gdpr'
  },

  sentry: {
    dsn: 'https://ce7a6433a63144bdae84f3cc66f292af@logging.abac.software/5',
    tracingOrigins: ['localhost']
  },

  toasts: {
    duration: 5000
  },

  formatDate: 'DD/MM/YYYY',
  formatTime: 'HH:mm',
  formatDateTime: 'DD/MM/YY - HH:mm',

  components: {
    table: {
      defaultItemsPerPage: 10
    }
  },


  loggerLevel: NgxLoggerLevel.DEBUG

};
